import SpecialBuyModuleEtch1 from './SpecialBuyModuleEtch1.component';

export default SpecialBuyModuleEtch1;
